import React, { useState, useRef, useEffect } from 'react';
import { PriceBlock, Typography, TextField, Modal, Button, Link, Loader } from '@hpstellar/core';
import { Cross } from '@hpstellar/icons';

import { EtrAPI } from '../../core/src/etr-api-client';
import Recaptcha from '../../shared/components/recaptcha';
import { Helpers } from '../../core';

import './gift-card-balance.less';

const initialInput = {
    giftCardNumber: null,
    pin: null,
    balance: 0,
};

const GiftCardBalance = ({
    animationType = 'fade-in',
    title = "Check Your Gift Card's Balance",
    isOpen = true,
    onModalClose,
}) => {
    const [giftCardNumber, setGiftCardNumber] = useState(initialInput.giftCardNumber);
    const [giftCardError, setGiftCardError] = useState();
    const [pin, setPin] = useState(initialInput.pin);
    const [pinError, setPinError] = useState();
    const [gcBalance, setGCBalance] = useState(initialInput.balance);
    const [token, setToken] = useState();
    const formRef = useRef();
    useEffect(() => {
        return () => {
            //reset to initial values
            setGiftCardNumber(initialInput.giftCardNumber);
            setPin(initialInput.pin);
            setGCBalance(initialInput.balance);
        };
    }, [isOpen]);
    //track state in mutable form Ref so that recaptch callback can access them.
    formRef.current = {
        giftCardNumber,
        pin,
    };
    const submitForm = (captchaToken, onModalClose = () => {}) => {
        EtrAPI.cart.getGiftCardBalance(formRef.current.giftCardNumber, formRef.current.pin, captchaToken).then(resp => {
            const { error, amount } = resp;
            if (error) {
                if (/PIN/g.test(error)) {
                    setPinError(error);
                } else {
                    setGiftCardError(error);
                }
            }
            let parsedAmount = Helpers.convertPriceToNumber(amount);
            setGCBalance(parsedAmount);
            setToken(null);
            try {
                window.grecaptcha.reset();
            } catch (e) {}
        });
    };
    const onFormSubmit = () => {
        if (!giftCardNumber || !pin) {
            !giftCardNumber && setGiftCardError('Gift card 19 digits number is required.');
            !pin && setPinError('PIN is required.');
            return;
        }
        if (pinError) {
            setPinError(null);
        }
        if (giftCardError) {
            setGiftCardError(null);
        }
        if (token) {
            submitForm(token, onModalClose);
        } else {
            try {
                window.grecaptcha.execute();
            } catch (e) {}
        }
    };

    return (
        <>
            <Modal
                animationType={animationType}
                withBackdrop
                isOpen={isOpen}
                onModalClose={onModalClose}
                modalClassName={`gc-balance-modal`}
            >
                <div className="gc-balance-content">
                    <button type="button" className="closeButton" aria-label="Close" onClick={onModalClose}>
                        <Cross size="m" />
                    </button>
                    <Typography id="modal_title" tag="h2" variant="headingTitleSmall">
                        {title}
                    </Typography>
                    <div className="gc-balance-form">
                        <div className="gc-balance-input">
                            <TextField
                                footNotePosition="left"
                                fieldProps={{
                                    name: 'input',
                                    type: 'text',
                                    onChange: e => {
                                        if (giftCardError) {
                                            setGiftCardError(null);
                                        }
                                        setGiftCardNumber(e.target.value);
                                    },
                                    defaultValue: giftCardNumber,
                                    maxlength: 19,
                                }}
                                label="Gift card number"
                                required
                                validate
                                error={giftCardError}
                            />
                            <div className="gc-pin">
                                <TextField
                                    className="gc-pin-input"
                                    footNotePosition="left"
                                    fieldProps={{
                                        name: 'input',
                                        type: 'password',
                                        onChange: e => {
                                            if (pinError) {
                                                setPinError(null);
                                            }
                                            setPin(e.target.value);
                                        },
                                        defaultValue: pin,
                                        maxlength: 4,
                                    }}
                                    label="PIN"
                                    required
                                    validate
                                    error={pinError}
                                />
                                <div className="gc-link-container">
                                    <Link
                                        icon="external"
                                        dense={true}
                                        size={'small'}
                                        target="_blank"
                                        to="/us-en/shop/ContentView?catalogId=10051&langId=-1&storeId=10151&eSpotName=CreditCardInfo"
                                    >
                                        Where is the pin number?
                                    </Link>{' '}
                                </div>
                            </div>
                        </div>
                        <div className="gc-balance">
                            {token ? (
                                <Loader />
                            ) : (
                                <>
                                    <Typography tag="h3" variant="headingTitleSmall">
                                        {'Balance'}
                                    </Typography>
                                    <PriceBlock regularPrice={gcBalance} />
                                </>
                            )}
                        </div>
                    </div>
                    <Button
                        className="submit-btn"
                        size="large"
                        variation={'secondary'}
                        isFullWidth={false}
                        onClick={onFormSubmit}
                    >
                        Check Balance
                    </Button>
                </div>
            </Modal>
            {isOpen ? (
                <Recaptcha
                    name="giftCardBalance"
                    callback={respToken => {
                        setToken(respToken);
                        submitForm(respToken, onModalClose);
                    }}
                />
            ) : null}
        </>
    );
};

export default GiftCardBalance;
